/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Pricing_ExtendInputs */

const en_pricing_extend = /** @type {(inputs: Pricing_ExtendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extend ${i?.duration}`)
};

const id_pricing_extend = /** @type {(inputs: Pricing_ExtendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perpanjang ${i?.duration}`)
};

/**
* | output |
* | --- |
* | "Extend {duration}" |
*
* @param {Pricing_ExtendInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_extend = /** @type {((inputs: Pricing_ExtendInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_ExtendInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_extend(inputs)
	return en_pricing_extend(inputs)
});